import React from 'react'
import Loading from '../../../components/loading'
import {browserHistory} from 'react-router'
import Empty from '../../../components/empty'
import ConfirmButton from '../../../components/confirmbutton'
import {TextArea, Checkbox, Table, Form, Message, Select, Image, Icon} from 'semantic-ui-react'
import {
  getCustomFieldsAction, postCustomFieldAction, deleteCustomFieldAction, getEditCustomFieldAction,
  postEditCustomFieldAction
} from '../../../actions/customfield.action'
import {getTemplatesAction} from '../../../actions/template.action'
import {connect} from 'react-redux'
import PickList from './components/PickList'
import {createAPIClient} from '../../../services/api'
import EditForm from './components/edit'
import TemplateEdit from '../templates/components/edit'
const {Field, Button} = Form

class TemplateCustomisation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      customFields: [],
      isLoading: false,
      template: {id: undefined, name: undefined},
      assignee: undefined,
      newSelectionValue: '',
      pickListItems: [],
      showEditForm: false,
      lastPosition: 0,
      firstPosition: 0,
      newForm: {
        error: false,
        errorMessage: undefined,
        value_type: 'Text',
        isLoading: false,
        postSuccess: false,
        field_name: '',
        field_title: '',
        authenticator: '',
        required: false
      },
      editForm: {
        error: false,
        errorMessage: undefined,
        isLoading: false,
        postSuccess: false,
        postFail: false,
        name: '',
        title: '',
        authenticator: '',
        value_type: '',
        value_list: [],
        required: false
      },
      editTemplate: false
    }
  }
  loadData (templateId = this.props.params.templateId) {
    const api = createAPIClient()
    api.get(`/api/templates/${templateId}`)
      .then(result => {
        const {data: body} = result
        const {response} = body
        const customFields = response.custom_fields
        console.log(customFields)
        const assignee = response.assignee
        customFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
        let lastPosition = customFields[customFields.length - 1] ? customFields[customFields.length - 1].position : 0
        let firstPosition = customFields[0] ? customFields[0].position : 0
        for (let i = 0; i < customFields.length; i++) {
          if (customFields[i].position === -1) {
            customFields[i].position = lastPosition + 1
            lastPosition += 1
            api.put(`/api/customfields/${customFields[i].id}`, {position: customFields[i].position})
              .then(result => {
                // this.loadData()
              })
              .catch(error => {
                console.log(error)
              })
          }
        }
        customFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
        this.setState({assignee: assignee, customFields: customFields, lastPosition: lastPosition, firstPosition: firstPosition})
      })
      .catch(error => {
        console.log(error)
      })
  }
  moveDown (index) {
    if (this.state.customFields[index].position === this.state.lastPosition) {
      return
    }
    const customFields = this.state.customFields
    const tempPosition = customFields[index].position
    customFields[index].position = customFields[index + 1].position
    customFields[index + 1].position = tempPosition
    customFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
    this.setState({customFields: customFields})
    const api = createAPIClient()
    api.put(`/api/customfields/${customFields[index].id}`, {position: customFields[index].position})
      .then(result => {
        // this.loadData()
      })
      .catch(error => {
        console.log(error)
      })
    api.put(`/api/customfields/${customFields[index + 1].id}`, {position: customFields[index + 1].position})
      .then(result => {
        // this.loadData()
      })
      .catch(error => {
        console.log(error)
      })
  }
  moveUp (index) {
    if (this.state.customFields[index].position === this.state.firstPosition) {
      return
    }
    const customFields = this.state.customFields
    const tempPosition = customFields[index].position
    customFields[index].position = customFields[index - 1].position
    customFields[index - 1].position = tempPosition
    customFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
    this.setState({customFields: customFields})
    const api = createAPIClient()
    api.put(`/api/customfields/${customFields[index].id}`, {position: customFields[index].position})
      .then(result => {
        // this.loadData()
      })
      .catch(error => {
        console.log(error)
      })
    api.put(`/api/customfields/${customFields[index - 1].id}`, {position: customFields[index - 1].position})
      .then(result => {
        // this.loadData()
      })
      .catch(error => {
        console.log(error)
      })
  }
  componentDidMount () {
    this.loadData()
  }

  componentWillUpdate (nextProps) {
    if (nextProps.shouldUpdate) {
      this.loadData()
    }
    if (this.props.params.templateId !== nextProps.params.templateId) {
      this.loadData(nextProps.params.templateId)
    }
    if (nextProps.templates.length !== 0 && (nextProps.templates !== this.props.templates || this.state.template.id === undefined) || this.props.params.templateId !== nextProps.params.templateId) {
      let currentTemplate
      let available = false
      for (let i = 0; i < nextProps.templates.length; i++) {
        if (nextProps.templates[i].id === nextProps.params.templateId) {
          currentTemplate = {id: nextProps.params.templateId, name: nextProps.templates[i].name, cover_field: nextProps.templates[i].cover_field}
          this.setState({template: currentTemplate})
          available = true
          break
        }
      }
      if (!available) {
        browserHistory.push('/settings/templates')
      }
    }
  }

  onRemove (_id) {
    const api = createAPIClient()
    api.delete(`/api/customfields/${_id}`)
      .then(result => {
        this.loadData()
      })
      .catch(error => {
        console.log(error)
      })
  }

  onEdit (id) {
    const api = createAPIClient()
    api.get(`/api/customfields/${id}`)
      .then(result => {
        const editForm = Object.assign({}, this.state.editForm, {...result.data.response})
        this.setState({
          showEditForm: true,
          editForm: editForm,
          pickListItems: result.data.response.list_values
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  cancelEdit () {
    this.setState({
      showEditForm: false,
      pickListItems: []
    })
  }

  onEditFormSubmit (e) {
    const name = this.state.editForm.name
    const title = this.state.editForm.title
    const valueType = this.state.editForm.value_type
    const location = this.state.editForm.location
    const id = this.state.editForm.id
    const listValues = valueType === 'Picklist' ? this.state.pickListItems : []
    const required = this.state.editForm.required
    if (valueType === 'Picklist' && listValues.length < 2) {
      this.setState({
        editForm: {...this.state.editForm, error: true, errorMessage: 'Need at least two items for single select'}
      })
      return
    }
    const form = {
      name,
      title,
      value_type: valueType,
      location,
      list_values: listValues,
      required: required
    }
    const api = createAPIClient()
    api.put(`/api/customfields/${id}`, form)
      .then(result => {
        this.setState({
          showEditForm: false,
          editForm: {...this.state.editForm, error: false, errorMessage: undefined},
          newSelectionValue: '',
          pickListItems: []
        })
        this.loadData()
      })
      .catch(error => {
        this.setState({
          editForm: {...this.state.editForm, error: true, errorMessage: 'Could not create the field'}
        })
      })
  }

  onEditFormFieldChange (e) {
    const editForm = Object.assign({}, this.state.editForm, {
      [e.target.name]: e.target.value
    })
    this.setState({editForm: editForm})
  }
  onFormFieldChange (e) {
    const newForm = this.state.newForm
    newForm[e.target.name] = e.target.value
    this.setState({newForm})
  }
  onFormSubmit (e) {
    const fieldName = this.state.newForm.field_name
    const fieldTitle = this.state.newForm.field_title
    const fieldValueType = this.state.newForm.value_type
    const location = this.props.locations[0]
    const listValues = fieldValueType === 'Picklist' ? this.state.pickListItems : []
    if (fieldValueType === 'Picklist' && listValues.length < 2) {
      this.setState({
        newForm: {...this.state.newForm, error: true, errorMessage: 'Need at least two items for single select'}
      })
      return
    }
    const required = this.state.newForm.required

    const form = {
      name: fieldName,
      title: fieldTitle,
      value_type: fieldValueType,
      location: location,
      list_values: listValues,
      position: this.state.lastPosition + 1,
      required: required
    }

    if (fieldValueType === 'Single select (API)') {
      form['authenticator'] = this.state.newForm.authenticator
    }

    const api = createAPIClient()
    api.post('/api/customfields', form)
      .then(result => {
        const customFieldId = result.data.response.id
        api.get(`/api/templates/${this.props.params.templateId}`).then(result => {
          const templateId = this.props.params.templateId
          const currentCustomFields = result.data.response.custom_fields.map(customField => customField.id)
          currentCustomFields.push(customFieldId)
          api.put(`/api/templates/${templateId}`, {custom_fields: currentCustomFields})
            .then(result => {
              this.setState({
                newForm: {...this.state.newForm, error: false, errorMessage: undefined, postSuccess: true, field_title: '', field_name: '', required: false, value_type: 'Text'},
                newSelectionValue: '',
                pickListItems: []
              })
              this.loadData()
            })
            .catch(error => {
              this.setState({
                newForm: {...this.state.newForm, error: true, errorMessage: 'Could not create the field', postSuccess: false}
              })
            })
        })
      })
      .catch(error => {
        this.setState({
          newForm: {...this.state.newForm, error: true, errorMessage: 'Could not create the field', postSuccess: false}
        })
      })
  }
  randomString (length) {
    var text = ''
    const possible = 'abcdefghijklmnopqrstuvwxyz0123456789_-.'
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
  }
  onNewFormSelectChange (e, {value}) {
    let authenticator
    if (value === 'Single select (API)') {
      authenticator = this.randomString(9)
    }
    const newForm = Object.assign({}, this.state.newForm, {
      value_type: value,
      authenticator: authenticator
    })
    this.setState({newForm: newForm})
  }
  onEditFormSelectChange (e, {value}) {
    const editForm = Object.assign({}, this.state.editForm, {
      value_type: value
    })
    this.setState({editForm: editForm})
  }
  handlePickListAddClick (e) {
    const selectionValue = this.state.newSelectionValue
    if (selectionValue === '') {
      return
    }
    const updatedValue = Object.assign([], this.state.pickListItems)
    if (updatedValue.indexOf(selectionValue) !== -1) {
      this.setState({
        newSelectionValue: ''
      })
      return
    }
    updatedValue.push(selectionValue)

    this.setState({
      pickListItems: updatedValue,
      newSelectionValue: ''
    })
  }
  onPickListFieldChange (e) {
    this.setState({
      newSelectionValue: e.target.value
    })
  }
  onPickListItemDelete (item) {
    let updatedValue = Object.assign([], this.state.pickListItems)
    var index = updatedValue.indexOf(item)
    if (index > -1) {
      updatedValue.splice(index, 1)
    }
    this.setState({
      pickListItems: updatedValue
    })
  }
  editTemplate () {
    this.setState({editTemplate: true})
  }
  finishTemplateEditing (reload) {
    this.setState({editTemplate: false})
    if (reload) {
      this.props.getTemplatesAction(results => {
      })
      this.loadData()
    }
  }
  onNewFormMandatoryChange (e, {checked}) {
    const newForm = Object.assign({}, this.state.newForm, {
      required: checked
    })
    this.setState({newForm: newForm})
  }
  onEditFormMandatoryChange (e, {checked}) {
    const editForm = Object.assign({}, this.state.editForm, {
      required: checked
    })
    this.setState({editForm: editForm})
  }
  render () {
    if (this.state.isLoading) {
      return <Loading />
    }
    const tableRows = (
      <Table.Body>
        {this.state.customFields.map((customField, index) => {
          var fieldType
          if (customField.value_type === 'Picklist') {
            fieldType = 'Single select'
          } else if (customField.value_type === 'TeamMember') {
            fieldType = 'Team member'
          } else if (customField.value_type === 'Calendar') {
            fieldType = 'Calendar'
          } else if (customField.value_type === 'Single select (API)') {
            fieldType = 'Single select (API)'
          } else {
            fieldType = 'Text'
          }
          return (

            <Table.Row key={customField._id}>
              <Table.Cell>
                <a href='#'>
                  <Image onClick={this.onEdit.bind(this, customField._id)} avatar src={'/icons/expand_1369826.svg'} />
                </a>
              </Table.Cell>
              <Table.Cell><ShortText textValue={customField.name} /></Table.Cell>
              <Table.Cell><ShortText textValue={customField.title} /></Table.Cell>
              <Table.Cell>{fieldType}</Table.Cell>
              <Table.Cell>{customField.required === false ? 'False' : 'True'}</Table.Cell>

              <Table.Cell>
                <Icon style={{cursor: 'pointer'}} disabled={this.state.lastPosition === customField.position} onClick={this.moveDown.bind(this, index)} name='caret square down' />
                <Icon style={{cursor: 'pointer'}} disabled={this.state.firstPosition === customField.position} onClick={this.moveUp.bind(this, index)} name='caret square up' />
              </Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )

    const table = (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>Title</Table.HeaderCell>
            <Table.HeaderCell>Placeholder</Table.HeaderCell>
            <Table.HeaderCell>Value Type</Table.HeaderCell>
            <Table.HeaderCell>Required</Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>
        {tableRows}
      </Table>
    )
    const fieldTypes = [
      {key: 1, value: 'Text', text: 'Text'},
      {key: 2, value: 'Picklist', text: 'Single select'},
      {key: 3, value: 'Single select (API)', text: 'Single select (API)'},
      {key: 4, value: 'TeamMember', text: 'Team member'},
      {key: 5, value: 'Calendar', text: 'Calendar'}
    ]
    const form = (
      <div>
        <h2> New custom field</h2>
        <Form loading={this.state.newForm.isLoading} onSubmit={this.onFormSubmit.bind(this)}>
          {this.state.newForm.postSuccess ? (<Message positive>
            <Message.Header>Successfully created new custom field</Message.Header>
          </Message>) : undefined}

          {this.state.newForm.error ? (<Message negative>
            <Message.Header>{this.state.newForm.errorMessage}</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='field_name'>Title*</label>
            <TextArea rows={1} autoHeight id='field_name' name='field_name' onChange={this.onFormFieldChange.bind(this)} value={this.state.newForm.field_name} required />
          </Field>
          <Field>
            <label htmlFor='field_title'>Placeholder*</label>
            <TextArea rows={1} autoHeight id='field_title' name='field_title' onChange={this.onFormFieldChange.bind(this)} value={this.state.newForm.field_title} required={this.state.newForm.value_type !== 'Picklist'} disabled={this.state.newForm.value_type === 'Picklist'} />
          </Field>
          <Field>
            <label htmlFor='field_value_type'>Value Type</label>
            <Select id='field_value_type' name='field_value_type' defaultValue={this.state.newForm.value_type} options={fieldTypes} onChange={this.onNewFormSelectChange.bind(this)} />
          </Field>
          {this.state.newForm.value_type === 'Picklist' ? (
            <PickList
              handlePickListAddClick={this.handlePickListAddClick.bind(this)}
              onPickListFieldChange={this.onPickListFieldChange.bind(this)}
              pickListItems={this.state.pickListItems}
              newSelectionValue={this.state.newSelectionValue}
              onPickListItemDelete={this.onPickListItemDelete.bind(this)}
            />
          ) : undefined }
          {this.state.newForm.value_type === 'Single select (API)' ? (
            <div style={{marginBottom: '20px'}}>
              <p><strong>Please follow below Curl command as an example to add values to this field</strong></p>
              <p>{`curl -X POST ${process.env.REACT_APP_BACKEND_API}/webhook/customfields/api-values -H 'Content-Type: application/json' -d '{"authenticator": "${this.state.newForm.authenticator}", "list_values": ["alpha", "beta"]}'`}</p>
            </div>
            ) : undefined}
          <Field>
            <Checkbox label='Make this field required' checked={this.state.newForm.required} onChange={this.onNewFormMandatoryChange.bind(this)} />
          </Field>
          <Button primary type='submit'>Add field</Button>
        </Form>
      </div>
    )

    return (
      <div>
        <p><span style={{fontSize: '20px', fontWeight: 'bold'}}>{this.state.template.name}</span> &nbsp; <a href='#' onClick={this.editTemplate.bind(this)}>(Edit)</a></p>
        {/*<p>{this.state.assignee && '( Assigned to : ' + this.state.assignee.first_name + ' ' + this.state.assignee.last_name + ' | ' + this.state.assignee.email + ' )'}</p>*/}
        {table}
        <br />
        {form}
        <EditForm
          filedTypes={fieldTypes}
          showEditForm={this.state.showEditForm}
          editForm={this.state.editForm}
          onEditFormSubmit={this.onEditFormSubmit.bind(this)}
          onEditFormFieldChange={this.onEditFormFieldChange.bind(this)}
          onEditFormSelectChange={this.onEditFormSelectChange.bind(this)}
          onEditFormMandatoryChange={this.onEditFormMandatoryChange.bind(this)}
          handlePickListAddClick={this.handlePickListAddClick.bind(this)}
          onPickListFieldChange={this.onPickListFieldChange.bind(this)}
          pickListItems={this.state.pickListItems}
          newSelectionValue={this.state.newSelectionValue}
          onPickListItemDelete={this.onPickListItemDelete.bind(this)}
          cancelEdit={this.cancelEdit.bind(this)}
          onRemove={this.onRemove.bind(this)}
        />
        <TemplateEdit
          template={{...this.state.template, assignee: this.state.assignee ? this.state.assignee.id:undefined}}
          customFields={this.state.customFields}
          showEditForm={this.state.editTemplate}
          finishTemplateEditing={this.finishTemplateEditing.bind(this)}
        />
      </div>
    )
  }
}
class ShortText extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isShort: true
    }
  }
  onClickAction () {
    this.setState({
      isShort: !this.state.isShort
    })
  }
  render () {
    var displayValue = this.props.textValue
    if (displayValue === undefined || displayValue === '') {
      return (<p />)
    }
    if (displayValue.length < 25) {
      return (
        <p>{displayValue}</p>
      )
    }
    if (this.state.isShort) {
      displayValue = displayValue.substring(0, 25)
    }
    return (
      <p>{displayValue}<a onClick={this.onClickAction.bind(this)} href='#'>{this.state.isShort ? ' ...' : ' Show less'}</a></p>
    )
  }
}
function mapStateToProps (state) {
  return {locations: state.account.user.locations, templates: state.templates.templates}
}

export default connect(mapStateToProps, {
  getTemplatesAction
})(TemplateCustomisation)



// WEBPACK FOOTER //
// ./src/pages/settings/template-customisation/index.js